import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 下载中心  获取下载列表
 */
export async function queryDownloadPage(param) {
  let data = [];
  let total = 0;

  param = JSON.parse(JSON.stringify(param));

  try {
    const { code, context, message } = await Http.post<{ data: []; total: number }>(`${hostUrl}/side/file-pack/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}